/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";

import {
  Form as FormUi,
  Container,
  TextArea,
  Button,
  Input,
  Segment,
  Dropdown,
  Divider,
  Icon,
  Search,
  Header,
  Grid,
  FormGroup,
} from "semantic-ui-react";
import "react-datepicker/dist/react-datepicker.css";
import { DateData } from "../dynamicComponent/datepick";
import ConsigneeWithCreate from "../dynamicComponent/consigneeWithCreate";
import ConsignorWithCreate from "../dynamicComponent/consignorWithCreate";
import ModalCreateConsignee from "../createShipmentComponent/modalCreateConsignee";
import ModalCreateConsignor from "../createShipmentComponent/modalCreateConsigner";
import BillingPartyWithCreate from "../dynamicComponent/billingPartyWithCreate";
import BillingPartyBranch from "../dropdowns/billingPartyBranch";
import ModalCreateBillingParty from "../createShipmentComponent/modalCreateBillingParty";
import BranchDropdown from "../dropdowns/branchDropdown";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import {
  createShipmentDispatcher,
  deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";

const AddOrderImport = ({
  values,
  vehicleTypeMaster,
  setFieldValue,
  touched,
  errors,
  handleSubmit,
  shipment,
  bookingRequestObj,
  routeCodes,
  routeNames,
  mode,
  isSubmitting,
  deleteAllOrderDispatcher,
  t,
  ...props
}) => {

  useEffect(() => {
    console.log("++++++++++++++------------0000000009999999999")
  }, []);

  const [routeAddressState, setRouteAddressState] = useState("");
  const [masterState, setMasterState] = useState("");
  const getMasterBranchSelected = (branchCode, branchData) => {
    const addedMasterBranchObject = branchData.find(
      (data) => data.branchId === branchCode
    );
    //setMasterState(addedMasterBranchObject.stateId);
  };

  const [consignorAddressState, setConsignorAddressState] = useState("");
  const [consigneeAddressState, setConsigneeAddressState] = useState("");
  /* const setBillingBranch = (billingBranch) => {
    setBillingBranchState(billingBranch);
  }; */

  const [billingBranchState, setBillingBranchState] = useState("");
  const [billingPartyBranchList, setBillingPartyBranchList] = useState("");
  const setBillingBranch = (billingBranch) => {
    setBillingBranchState(billingBranch);
  };

  const [billingPartyBranch, setBillingPartyBranch] = useState("");
  const setBillingPartyBranchSelected = (
    billingBranchCode,
    billingBranchData
  ) => {
    const addedBillingBranchObject = billingBranchData
      .find
      //(data) => data.branchCode === branchCode
      ();
    //setBillingBranchState(addedBillingBranchObject.stateId);
  };


  return (
    <div>
      <Formiker>
      <Segment>
         
         <Header as='h3' className="heading-01" content='Order Details' textAlign='left' />
       <Divider clearing />

       <div className="ui form tiny p-bold-600">
       <FormGroup>
       <FormUi.Field width={3}>
       <label>
       {t("shipment_form.order_numbers.title") || "Order Number"}{" "}
          </label></FormUi.Field>
       <FormUi.Field width={4}>
       <Input fluid Field placeholder='DH12563' /></FormUi.Field>
       <FormUi.Field width={1} />
       <FormUi.Field width={3}>
         <label>{t("shipment_form.weight(in_kg).title") || "Weight(in Kg)"}{" "} </label> 
         </FormUi.Field>
       <FormUi.Field width={4}>
       <Input fluid Field placeholder='500' /></FormUi.Field>
       </FormGroup>
     
       <FormGroup>
       <FormUi.Field width={3}>
       <label>{t("shipment_form.ownership_type.title") || "Ownership Type"}{" "} </label></FormUi.Field>
       <FormUi.Field width={4}>
       <Dropdown
               name="Market"
               clearable
               search
               style={{ width: "100%" }}
               selection
               placeholder={""}
               options={[
                 { key: "3", text: "Primary", value: "primary" },
                 { key: "2", text: "Import", value: "import" },
                 { key: "4", text: "Export", value: "export" },
               ]}
             ></Dropdown></FormUi.Field>
       <FormUi.Field width={1} />
       <FormUi.Field width={3}></FormUi.Field>
       <FormUi.Field width={4}></FormUi.Field>
       </FormGroup>

       <FormGroup>
       <FormUi.Field width={3}>
       <label>{t("shipment_form.vendor.title") || "Vendor"}{" "} </label></FormUi.Field>
       <FormUi.Field width={4}>
        <Dropdown
               name="Vendor"
               clearable
               search
               style={{ width: "100%" }}
               selection
               placeholder={""}
               options={[
                 { key: "3", text: "Primary", value: "primary" },
                 { key: "2", text: "Import", value: "import" },
                 { key: "4", text: "Export", value: "export" },
               ]}

             /></FormUi.Field>
       <FormUi.Field width={1} />
       <FormUi.Field width={3}>
       <label>{t("shipment_form.required_vechicle_type.title") || "Required Vechicle Type:"}{" "} </label> 
       </FormUi.Field>
       <FormUi.Field width={4}> <Input fluid Field placeholder='32 Feet' /></FormUi.Field>
       </FormGroup>

</div>


     </Segment>

     <Segment>
       <Header as='h3' className="heading-01" content='Delivery Details' textAlign='left' />
       <Divider clearing />
       <div className="ui form tiny p-bold-600">

         <FormUi.Group>
           <FormUi.Field width={4}>
           <label>{t("shipment_form.delivery_number.title") || "Delivery Number"}{" "} </label> 
             <input placeholder='DN0112' error={touched.movement_type && errors.movement_type ? true : false}></input>
           </FormUi.Field>


           <FormUi.Field width={4}>
             {localStorage.getItem('customerNumber') == 549 ?
             <label>{t("shipment_form.port_terminal.title") || " Port terminal"}{" "} </label> 
              
               :
               <label className="required-form-element">{t("shipment_form.port_terminal.title") || " Port terminal"}{" "} </label> 
             }
             <Fieldmik
               disabled={mode == "view" ? true : false}
               // placeholder={
               //   values.deliveries[i].consignee_placeholder
               // }
               component={ConsigneeWithCreate}
               // name={`deliveries[${i}].consignee_code`}
               // consigneeRaw={`deliveries[${i}].consigneeRaw`}
               // consignee_placeholder={`deliveries[${i}].consignee_placeholder`}
               // setRaw="consigneeRaw"
               //fillAddressState={setConsigneeAddressState}
               error={
                 touched.consignee && errors.consignee ? true : false
               }
             />
           </FormUi.Field>


           <FormUi.Field width={4}>
           <label>{t("shipment_form.delivery_location.title") || "Delivery Location"}{" "} </label> 
             
             <Fieldmik
               // disabled={mode == "view" ? true : false}
               // placeholder={
               //   values.deliveries[i].consignor_placeholder
               // }
               component={ConsignorWithCreate}
             // name={`deliveries[${i}].consignor_code`}
             // consignorRaw={`deliveries[${i}].consignorRaw`}
             // consignor_placeholder={`deliveries[${i}].consignor_placeholder`}
             // setRaw="consignorRaw"
             // //fillAddressState={setConsignorAddressState}
             // error={
             //   touched.consignor && errors.consignor ? true : false
             // }
             />
           </FormUi.Field>

           <FormUi.Field width={4}>
           <label>{t("shipment_form.booking_branch.title") || "Booking Branch"}{" "} </label> 
             <Input fluid Field placeholder='Mumbai' />
           </FormUi.Field>
         </FormUi.Group>



         <FormUi.Group>
           <FormUi.Field width={4}>
           <label>{t("shipment_form.billing_party.title") || "Billing Party"}{" "} </label> 
             <input placeholder='DN0112' error={touched.movement_type && errors.movement_type ? true : false}></input>
           </FormUi.Field>


           <FormUi.Field width={4}>
           <label>{t("shipment_form.billing_party_branch.title") || "Billing Party Branch"}{" "} </label>
             
             <Fieldmik
               disabled={mode == "view" ? true : false}
               //placeholder={values.billing_party_placeholder}
               // placeholder={
               // values.deliveries[i].billing_party_placeholder

               component={BillingPartyWithCreate}
               // placeholderName={`deliveries[${i}].billing_party_placeholder`}
               // name={`deliveries[${i}].billing_party_id`}
               dataId="billingBranchState"
               setBillingBranch={setBillingBranch}
             />
           </FormUi.Field>


           <FormUi.Field width={4}>
           <label>{t("shipment_form.booking_branch.title") || "Booking Branch"}{" "} </label>
             <Input fluid Field placeholder='Mumbai' />
           </FormUi.Field>

           <FormUi.Field width={4}> </FormUi.Field>
         </FormUi.Group>



         <FormUi.Group>
           <FormUi.Field width={4}>
           <label>{t("shipment_form.container_name.title") || "Container Name"}{" "} </label>
           <Input fluid Field placeholder='CN002' />
           </FormUi.Field>

           <FormUi.Field width={4}>
           <label>{t("shipment_form.container_type.title") || "Container Type"}{" "} </label>
               <select fluid Field placeholder='20 Feet' />
           </FormUi.Field>


           <FormUi.Field width={4}>
           <label>{t("shipment_form.container_pickup_date.title") || "Container Pickup Date"}{" "} </label>
           <Input fluid Field placeholder='03-11-2021' />
           </FormUi.Field>

           <FormUi.Field width={4}>
           <label>{t("shipment_form.container_drop_date.title") || "Container Drop Date"}{" "} </label>
           <Input fluid Field placeholder='03-11-2021' />
           </FormUi.Field>
         </FormUi.Group>



         <FormUi.Group>

           <FormUi.Field width={4}>
           <label>{t("shipment_form.container_drop_location.title") || "Container Drop Location"}{" "} </label>
               <select fluid Field placeholder='Select Drop Location' />
           </FormUi.Field>

           <FormUi.Field width={4}>
           <label>{t("shipment_form.storage_expiration.title") || "Storage Expiration"}{" "} </label>
           <Input fluid Field placeholder='20-10-2021' />
           </FormUi.Field>

           <FormUi.Field width={4}>
           <label>{t("shipment_form.demurrage_expiration.title") || "Demurrage Expiration"}{" "} </label>
           <Input fluid Field placeholder='03-11-2021' />
           </FormUi.Field>

           <FormUi.Field width={4}>
           <label>ETA </label>
           <Input fluid Field placeholder='03-11-2021' />
           </FormUi.Field>
         </FormUi.Group>

         <Segment>
         <Header as='h3' className="heading-01" content='Invoice 1' textAlign='left' />
         <div className="right-float"><Button size="mini" color="blue" inverted icon labelPosition='left'>
           <Icon name='add' />
           Invoice
         </Button></div>
         <Divider clearing></Divider>
         
         <Formiker>
           <FormUi.Field>
           <div className="ui form tiny p-bold-600">
             <Grid columns='equal' className="table-grid">
               <Grid.Row className="table-grid-row">
                 <Grid.Column>{t("shipment_form.invoice_number.title") || "Invoice No."}{" "}</Grid.Column>
                 <Grid.Column>{t("shipment_form.bl_no.title") || "BL Number"}{" "}</Grid.Column>
                 <Grid.Column>{t("shipment_form.invoice.title") || "Invoice"}{" "}</Grid.Column>
                 <Grid.Column>{t("shipment_form.weight(in_kg).title") || "Weight(in Kg)"}{" "}</Grid.Column>
                 <Grid.Column>{t("shipment_form.invoice_date.title") || "Invoice Date"}{" "}</Grid.Column>
                 <Grid.Column>{t("shipment_form.total_invoice_value.title") || "Total Invoice Value"}{" "}</Grid.Column>
               </Grid.Row>
               <Grid.Row>
                 <Grid.Column><Input fluid Field placeholder='1N0001' className="mrg-lft-20" /></Grid.Column>
                 <Grid.Column><Input fluid Field placeholder='BL000001' /></Grid.Column>
                 <Grid.Column width={3}><input type="file" size="mini"></input></Grid.Column>
                 <Grid.Column><Input fluid Field placeholder='BL000001' /></Grid.Column>
                 <Grid.Column><Input fluid Field placeholder='BL000001' /></Grid.Column>
                 <Grid.Column><Input icon='rupee' iconPosition='left' placeholder='10000' /></Grid.Column>


               </Grid.Row>
             </Grid>
             </div>
           </FormUi.Field>
          </Formiker>
         <br></br>
         <Header as='h3' className="heading-01" content='Product Details' textAlign='left' />
         <div className="right-float mt-20"><Button size="mini" color="blue" inverted icon labelPosition='left'>
           <Icon name='add' />
           Delivery
         </Button></div>
         <Divider clearing></Divider>
         <div className="ui form tiny p-bold-600">
         <Grid columns='equal' className="table-grid">
           <Grid.Row className="table-grid-row">
             <Grid.Column width={2}>{t("shipment_form.product_code.title") || "Product Code"}{" "}</Grid.Column>
             <Grid.Column width={2}>{t("shipment_form.product_name.title") || "Product Name"}{" "}</Grid.Column>
             <Grid.Column width={3}>{t("shipment_form.product_category_id.title") || "Product Category"}{" "}</Grid.Column>
             <Grid.Column>{t("shipment_form.quantity.title") || "Quantity"}{" "}</Grid.Column>
             <Grid.Column width={2}>{t("shipment_form.packaging_type_id.title") || "Packaging Type"}{" "}</Grid.Column>
             <Grid.Column>{t("shipment_form.rate.title") || "Rate"}{" "}</Grid.Column>
             <Grid.Column>Edit</Grid.Column>
             <Grid.Column>Delete</Grid.Column>
           </Grid.Row>
           <Grid.Row>
             <Grid.Column className="mrg-lft-20" width={2}>PD0001</Grid.Column>
             <Grid.Column width={2}>Drin</Grid.Column>
             <Grid.Column width={3}>Ambient</Grid.Column>
             <Grid.Column>100</Grid.Column>
             <Grid.Column width={2}>Box</Grid.Column>
             <Grid.Column>1000</Grid.Column>
             <Grid.Column><Button size="mini" color="green" inverted icon>
               <Icon name='edit' />
             </Button></Grid.Column>
             <Grid.Column><Button size="mini" color="red" inverted icon>
               <Icon name='trash' />
             </Button></Grid.Column>
           </Grid.Row>
         </Grid>
         </div>
       </Segment>

     <>
       <center>
         <Button
           type="submit"
           className="m-2"
           primary
           size="mini"
           onClick={handleSubmit}
           disabled={values.disable_submit}
         >
           Submit
         </Button>
       </center>
     </>
     </div>
</Segment>
      </Formiker>
    </div>
  );
};

const FormikShipment = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
  }),
  // setFieldValue("required_on", moment().format("DD/MM/yyyy hh:mm"));
  mapPropsToValues: (props) => ({
    disable_submit: false,

  }),
  handleSubmit(values, { setFieldValue, setSubmitting, props }) {
    setFieldValue("disable_submit", true);
  },
})(AddOrderImport)

const mapStateToProps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToProps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher,
  deleteAllOrderDispatcher,
})(translate("create_shipment")(FormikShipment));
